module.exports = __webpack_public_path__ + "img/red_036.dea12a1b.png";